module.exports = __webpack_public_path__ + "img/1-ExitusCredit.75117fab.jpg";